<template>
  <div class="bg-white h-100">
    <LmComponentLoading v-if="isLoading" />
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <div class="scroll">
      <a-timeline
        class="p-4"
        mode="alternate"
        v-if="movements.items.length"
      >
        <a-timeline-item
          v-for="(m, index) of movements.items"
          :key="index"
        >
          <a-icon
            v-if="m.icon"
            slot="dot"
            :type="m.icon"
            style="font-size: 22px;"
            :style="{color: m.color}"
          />
          <div class="datos d-flex flex-column mx-2">
            <span class="font-weight-bold" :style="{color: m.color}">{{ m.movement_code }}</span>
            <span>
              <b-avatar
                v-if="!m.noavatar"
                class="my-2"
                size="2.6em"
                :text="emptyUserAvatar(m)"
                :src="m.avatar"
                v-b-popover.hover="popoverConfig(m, index)"
              ></b-avatar>
              <span class="mx-2 font-weight-bold">{{`${userFullName(m)}`}}</span>
            </span>
            <!-- <span class="font-weight-bold">{{ m.created_by.firstname }} {{ m.created_by.lastname }}</span> -->
            <span
              v-if="m.destination.area"
            >
              <div class="mt-2"><strong>Área:</strong> {{m.destination.area.name}}</div>
            </span>
            <span
              v-if="m.destination.subarea"
            >
              <div class="mt-2"><strong>Subárea:</strong> {{m.destination.subarea.name}}</div>
            </span>
            <span
              v-if="m.destination.user"
            >
              <div v-if="m.destination.user?.area" class="mt-2"><strong>Área:</strong> {{m.destination.user.area.name}}</div>
              <div v-if="m.destination.user?.subarea"><strong>Subárea:</strong> {{m.destination.user.subarea.name}}</div>
            </span>
            <span
              v-if="m.created_at"
              class="font-weight-light"
            >
              {{ m.created_at }}
            </span>
          </div>
        </a-timeline-item>
      </a-timeline>
      <LmSvgIcon
        v-else
        wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column p-4"
        width="6em"
        icon="LmNoDataIcon"
        text="No hay movimientos."
      />
    </div>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import moment from 'moment'
import LmButton from '@/components/form/elements/LmButton'

import 'moment/locale/es'
moment.locale('es')

export default {
  props: {
    historyEndpoint: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      movements: {
        items: []
      }
    }
  },
  components: {
    LmButton
  },
  methods: {
    emptyUserAvatar (m) {
      if (m.avatar) {
        return null
      }
      if (m.destination.user) {
        return m.destination?.user?.firstname?.charAt(0) + m.destination?.user?.lastname?.charAt(0)
      }
      return null
    },
    userFullName (m) {
      if (m.destination?.user) {
        return `${m.destination?.user?.firstname} ${m.destination?.user?.lastname}`
      }
      if (m.destination?.area) {
        return `${m.oridestinationin?.area?.name}`
      }
      if (m.destination?.subarea) {
        return `${m.destination?.subarea?.name}`
      }
      if (m.destination?.group) {
        return `${m.destination?.group?.name}`
      }
    },
    popoverConfig (m, index) {
      return {
        content: () => this.userFullName(m),
        placement: index % 2 === 0 ? 'right' : 'left'
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      const res = await commonsApi.axiosGetWrapper(`${this.historyEndpoint}/${this.$route.params.id}`)
      this.movements.items = res.data?.rows || []
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="sass" scoped>
  .scroll
    height: calc(100% - 70px)
    overflow-y: auto
    &:hover
      &::-webkit-scrollbar-thumb
        border-radius: 20px
        background: #888
    &::-webkit-scrollbar
      width: 8px
    &::-webkit-scrollbar-thumb
      border-radius: 20px
      background: transparent
    &::-webkit-scrollbar-thumb:hover
      background: #555
</style>
